import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { useStore } from '@nanostores/react';

export const Profile = () => {
  const user = useStore($user);

  return (
    <div>
      <h2 className="text-xl font-semibold tracking-tight">Profile</h2>
      <p className="text-sm text-muted-foreground">
        Manage your profile information
      </p>

      <div className="mt-6 rounded-xl border p-4">
        <div className="flex flex-1 items-center">
          <Avatar className="mr-6 h-32 w-32 text-2xl">
            <AvatarImage src={user?.photoURL || ''} alt="Profile menu" />
            <AvatarFallback>
              {user?.displayName?.slice(0, 2).toLocaleUpperCase() || 'A'}
            </AvatarFallback>
          </Avatar>
          <div className="flex flex-1 flex-col">
            <p className="text-lg">{user?.displayName}</p>
            <p className="text-md text-muted-foreground">{user?.email}</p>
          </div>
        </div>
      </div>

      <div className="mt-6 rounded-xl border p-4">
        <h2 className="text tracking-tight">Personal Info</h2>

        <div className="mt-4 grid grid-cols-2 gap-4">
          <div className="flex flex-col">
            <div className="text-sm text-gray-500">Name</div>
            <div className="mt-1 text-sm">{user?.displayName}</div>
          </div>
          <div className="flex flex-col">
            <div className="text-sm text-gray-500">User ID</div>
            <div className="mt-1 text-sm">{user?.uid}</div>
          </div>
        </div>

        <div className="mt-6 grid grid-cols-2 gap-4">
          <div className="flex flex-col">
            <div className="text-sm text-gray-500">Email address</div>
            <div className="mt-1 text-sm">{user?.email}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
